import React, { useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft, FaFilePdf } from "react-icons/fa";

import styles from "./NewJobworkListPage.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { route } from "../../static/route";
import { useAppSelector } from "../../app/hooks";
import { getJobworks } from "../../features/newJobwork/newJobworkSlice";
import ListCard from "../../components/jobworks/ListCard";
import { POST } from "../../services/axios.service";

const NewJobworkListPage = () => {
  const navigate = useNavigate();
  const jobworks = useAppSelector(getJobworks);
  const { typeId } = useParams();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleGoToBack = () => {
    navigate(route.dashboard);
  };

  const handlePrintReport = async () => {
    setErrorMessage(null);
    try {
      await POST(`/v1/worker/jobworks-reports`, {
        jobwork_ids: jobworks.map((jobwork) => jobwork.id) || [],
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            setErrorMessage(response.data.message);
          }
          navigate(route.newJobwork.replace(":typeId", typeId || "1"));
        })
        .catch((error: any) => {
          setErrorMessage(error.data.message);
        });
    } catch (error) {
      setErrorMessage("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }
  };

  return (
    <Layout className="new-order-print-layout">
      <div className={styles.NewJobworkListPage}>
        <div className="w-full px-10 h-[200px] text-center flex flex-col justify-center relative">
          <FaArrowLeft
            onClick={handleGoToBack}
            className="absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-4xl mt-6 font-bold text-white">
            નવા કામ ની વિગત
          </h1>
        </div>

        <div className="w-full relative mt-[70px] px-10 py-5 lg:mt-[20px]">
          {jobworks && jobworks.length > 0 ? (
            <div>
              {jobworks.map((jobwork, index) => (
                <Link
                  to={route.jobworkDetails
                    .replace(":jobworkId", jobwork.id.toString())
                    .replace(":typeId", jobwork.type === 1 ? "2" : "1")}
                  key={index}
                >
                  <ListCard jobwork={jobwork} />
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center">
              <p className="mt-4 text-primary-2 font-bold text-2xl">
                હાલ કોઈ નવા કામ ની વિગતો મળી નથી.
              </p>

              <div className="w-full flex justify-center">
                <Link to={route.dashboard}>
                  <button
                    type="button"
                    className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  >
                    કામ ઉમેરો
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>

        {jobworks && jobworks.length > 0 && (
          <div className="w-full flex justify-center">
            <button
              className="mx-auto flex gap-3 mt-0 mb-6 shadow disabled:opacity-50 rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
              type="button"
              onClick={handlePrintReport}
            >
              <FaFilePdf className="text-white mt-1" />
              PDF
            </button>
            {errorMessage && (
              <p className="text-red-500 text-sm font-semibold text-center">
                {errorMessage}
              </p>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
};
export default NewJobworkListPage;
